import { useParams } from 'react-router-dom';

import { useApiQuery } from '@/shared/hooks/useApi';
import { api } from '@/shared/services/api';

import { OrderDetailData } from '../types/orderTypes';

export const useOrderDetail = () => {
  const { orderId } = useParams<{ orderId: string }>();

  const { data, isLoading, error, refetch } = useApiQuery(
    ['order', 'detail', orderId ?? ''],
    () => api.get<OrderDetailData>(`/api/v1/order/detail/${orderId}`),
    {
      enabled: !!orderId,
    },
  );

  return {
    orderData: data?.data,
    isLoading,
    error,
    refetch,
  };
};
